import { endAt, limit, orderBy, startAt } from "firebase/firestore";
import { Query } from "../library/query";
import { GoldRateDTO } from "../models/goldRate";
import { GoldRateStateData } from "../store/goldRateSlice";

const noRateFoundMessage = "No gold rate found.";
const noFreezedRateFoundMessage = "No frozen gold rate found.";




export class RateRepository {
    private static rateCollection = Query.getCollection('rates');

    static async todaysRate(): Promise<GoldRateDTO> {
        const rateData: any = await this.rateCollection.findOne(orderBy('timestamp', 'desc'), limit(1));
        if (!rateData) {
            throw new Error(noRateFoundMessage);
        }
        return GoldRateDTO.fromJSON(rateData);
    }

    static async ratesByTimeInterval(start: Date, end: Date) {
        const startTime = start.valueOf();
        const endTime = end.valueOf();
        const rateData = await this.rateCollection.searchDoc([orderBy('timestamp', 'desc'), startAt(startTime), endAt(endTime)]);
        return rateData.map((rate) => GoldRateDTO.fromJSON(rate))
    }

    static todaysRateOnChange(callback: (data: GoldRateDTO) => void): () => void {
        return this.rateCollection.findFirstWithSnapshot((snapshot) => {
            const rateData = snapshot;
            callback(GoldRateDTO.fromJSON(rateData));
        }, orderBy('timestamp', 'desc'), limit(1));
    }
    static async updateRate(id: string, data: any) {
        await this.rateCollection.updateDocById(id, {
            ...data,
        });
    }

    static async AddRate(data: any) {
        await this.rateCollection.addNewDoc({
            ...data,
        });
    }
}

export class FreezedRateRepository {
    private static freezedRateCollection = Query.getCollection('rates_freezed');

    static async latestFreezedRate() {
        const freezedRate = await this.freezedRateCollection.findOne(orderBy('timestamp', 'desc'), limit(1));
        if (!freezedRate) {
            throw new Error(noFreezedRateFoundMessage);
        }
        return freezedRate as GoldRateStateData & { id: string };
    }

    static async freezeRate(data: any) {
        return await this.freezedRateCollection.addNewDoc(data)
    }

    static async freezedRateById(id: string) {
        const rateData: any = await this.freezedRateCollection.findById(id);
        return GoldRateDTO.fromJSON(rateData);
    }

    static async getAllFreezedRates() {
        const rateData = await this.freezedRateCollection.getAllDocs();
        return rateData.map((rate) => GoldRateDTO.fromJSON(rate))
    }

    static async getAllFreezedRatesRaw(): Promise<(GoldRateStateData & { id: string })[]> {
        return await this.freezedRateCollection.getAllDocs() as (GoldRateStateData & { id: string })[];
    }

    static async fix24KRate(id: string, correctedRate: number) {
        const raw = await this.freezedRateCollection.getDocById(id) as GoldRateStateData & { id: string };
        if (!raw) return;
        return await this.freezedRateCollection.updateDocById(id, {
            gold: { ...raw.gold, '24K': correctedRate },
        });
    }
}

export class RateDiffRepository {
    private static rateDiffCollection = Query.getCollection('ratesdiff');

    static async UpdateDiff(diff: number) {
        return await this.rateDiffCollection.updateDocById('6vQJVeAW3KaSo5vjl0xh', { difference: diff });
    }

    static async latestRateDiff() {
        return await this.rateDiffCollection.findById('6vQJVeAW3KaSo5vjl0xh') as { difference: number } & { id: string };
    }
}